import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import SnackbarMessage from './SnackbarMessage.vue';

function Snackbar({ message, timeout }) {
	let modal = document.createElement('div');
	document.body.appendChild(modal);

	return new Promise((resolve) => {
		let vModal = new Vue({
			vuetify,
			el: modal,
			components: {
				SnackbarMessage,
			},
			data: {
				isVisible: true,
				timeout: timeout || 5000,
				message: message,
			},
			methods: {
				kill() {
					modal = vModal.$el;
					vModal.$destroy();
					if (modal.parentNode) {
						modal.parentNode.removeChild(modal);
					}
				},
				onCancel() {
					this.isVisible = false;
					resolve(0);
					this.kill();
				},
			},
			template: `<snackbar-message :isVisible="isVisible" :message="message" :timeout="timeout" @cancel="onCancel" />`,
		});
	});
}

export default Snackbar;
